import api from './api';

/**
 * BIGLI-67：讀 GET /api/version（src/server/index.js），給畫面上的版本印記用。
 *
 * 純加值資訊：打不到、回錯格式都回 null，呼叫端把印記藏起來即可，
 * 絕不能因為這支失敗而影響任何頁面的主要功能。
 */
export const getBuildVersion = async () => {
  try {
    const response = await api.get('/version');
    const data = response && response.data;
    if (!data || typeof data !== 'object') return null;
    const fingerprintShort = (data.sourceFingerprint && data.sourceFingerprint.short) || null;
    // 指紋算不出來（伺服器回 { error }）就沒有東西可印，直接當作拿不到
    if (!fingerprintShort) return null;
    return {
      mainBundle: data.mainBundle || null,
      builtAt: data.builtAt || null,
      fingerprintShort,
    };
  } catch (error) {
    return null;
  }
};

/**
 * BIGLI-67（PM Bridget 2026-10-01「為何此情況會一再出現」）：這個分頁「自己正在跑」的 main bundle 檔名。
 *
 * /api/version 回的是伺服器現在服務的那一包；但分頁若在換包前就開著，瀏覽器手上仍是舊 JS，
 * SPA 內換頁不會重抓 index.html，所以會一直停在舊畫面直到手動重整。
 * 比對兩邊檔名（含 content hash）不同 → 這個分頁是舊包。開發模式（bundle.js、無 hash）回 null。
 */
export const getRunningMainBundle = (doc = typeof document !== 'undefined' ? document : null) => {
  if (!doc) return null;
  const scripts = Array.from(doc.querySelectorAll('script[src]'));
  for (const s of scripts) {
    const m = (s.getAttribute('src') || '').match(/\/static\/js\/(main\.[a-z0-9]+\.js)/);
    if (m) return m[1];
  }
  return null;
};

/**
 * BIGLI-92：App 每次 SPA 換頁 dispatch 這個 window 事件，Footer 收到就立刻再比對一次版本，
 * 舊分頁點進報價單編輯時馬上跳提示，不用等定時輪詢。
 */
export const ROUTE_VERSION_CHECK_EVENT = 'gaffer:route-version-check';

/** 兩邊都拿得到、且不同才算舊包；任一邊拿不到就當作不知道（不跳提示）。 */
export const isStaleBundle = (runningBundle, servedBundle) =>
  Boolean(runningBundle && servedBundle && runningBundle !== servedBundle);

/**
 * 印記只取指紋前 6 碼（AC #5 指定）：夠短、肉眼一眼比得完，
 * 且與 npm run check:deployed／評論裡回報的 sourceFingerprint.short 前綴一致。
 */
export const formatVersionStamp = (version) => {
  const short = version && version.fingerprintShort;
  if (!short || typeof short !== 'string') return null;
  return short.slice(0, 6);
};
